<div class="row" *ngIf="movie">
    <div class="col-md-6">
        <img [src]="movie.poster_path | poster" [alt]="movie.title" class="img-thumbnail">
    </div>
    <div class="col-md-6">
        <h1>{{ movie.title }}</h1>
        <h5>{{ movie.tagline }}</h5>
        <div class="row">
            <div class="col">
                <small class="text-white-50 movie-genre" *ngFor="let genre of movie.genres">{{ genre.name }}</small>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <star-rating [value]="movie.vote_average / 2" checkedcolor="yellow" uncheckedcolor="grey" size="14px">
                </star-rating>
            </div>
            <div class="col">
                <p>{{ movie.vote_average}} / 10</p>
            </div>
        </div>

        <div class="row">
            <h6 class="text-white-50">OVERVIEW:</h6>
            <h4>{{ movie.overview | slice:0:500 }}</h4>
        </div>
        <div class="row mt-5">
            <div class="col">
                <button class="btn btn-primary" (click)="onRegresar()">BACK</button>
            </div>
        </div>
    </div>
</div>
<div class="row mt-5" *ngIf="cast.length > 0">
    <h2 class="text-center">CAST:</h2>
    <h6 class="text-center text-white-50">Scroll right to see all the characters of the film</h6>
    <div class="col">
        <app-cast-slideshow [cast]="cast"></app-cast-slideshow>
    </div>
</div>
<div class="row m-5" *ngIf="productionCompanies != null">
    <h3 class="text-center">PRODUCTION:</h3>
    <div class="col text-center" *ngFor="let companie of productionCompanies">
        <h5 class="">{{ companie.name }}</h5>
        <img *ngIf="companie.logo_path != undefined" [src]="companie.logo_path | poster" [alt]="companie.name" style="width: 50px; height: 50px;">
    </div>
</div>
<div class="row m-5 text-center" *ngIf="releaseDate">
    <h3 class="text-center">RELEASE DATE:</h3>
    <h4>{{releaseDate}}</h4>
</div>

<!--SIMILAR MOVIES-->
<div class="row mt-5" *ngIf="similars.length > 0">
    <h3 class="text-center">Similar Movies</h3>
    <app-slide-peliculas-similares [similars]="similars" (enviar)="goToMovie($event)"></app-slide-peliculas-similares>
</div>